module.exports = __webpack_public_path__ + "img/icomoon.4043c7b8.svg";